import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-attachment-details-modal',
  templateUrl: './attachment-details-modal.component.html',
  styleUrls: ['./attachment-details-modal.component.css']
})
export class AttachmentDetailsModalComponent {
  @Input() typeList: any
  @Input() details: any
  @Input() attachmentCount: any
  formData: { [key: string]: any };
  triggerDelete: boolean;

  constructor(private ngbActiveModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.formData = {};
    this.triggerDelete = false;

    if (this.details != null) {
      this.formData.attachmentType = this.details.AttachmentTypeID;
      this.formData.attachmentDescription = this.details.RawDescription;
    }
  }

  public triggerDeleteAttachment() {
    this.triggerDelete = true;
  }

  public resetTriggerDeleteAttachment() {
    this.triggerDelete = false;
  }

  public deleteAttachmentAndCloseModal () {
    this.ngbActiveModal.close({ cancel: false, delete: true });
  }

  public uploadClicked() {
    this.ngbActiveModal.close({ attachmentType: this.formData.attachmentType, attachmentDescription: this.formData.attachmentDescription, cancel: false, delete: false });
  }

  public cancelClicked() {
    this.ngbActiveModal.close({ cancel: true, delete: false });
  }
}
